export const industries = [
    {
        slug: "advanced-manufacturing",
        title: "Advanced Manufacturing",
        short: "Precision-critical facilities for the industries defining tomorrow.",
        sub: ["Electric Vehicles", "Pharmaceutical", "Biomedical", "Waste Treatment", "Battery Cell", "Semiconductor & Microchip"],
        image: "https://images.pexels.com/photos/18471441/pexels-photo-18471441.jpeg",
        code: "01",
    },
    {
        slug: "data-centers",
        title: "Mission Critical Data Centers",
        short: "Hyperscale and colo facilities engineered for 99.999% uptime.",
        sub: ["Tier III / IV", "Liquid Cooling", "Redundant Power", "Edge Compute"],
        image: "https://images.unsplash.com/photo-1680992046626-418f7e910589",
        code: "02",
    },
    {
        slug: "healthcare",
        title: "Healthcare",
        short: "Hospitals, surgical suites and research labs that save lives.",
        sub: ["Hospitals", "Surgical Centers", "Research Labs", "Imaging Suites"],
        image: "https://images.unsplash.com/photo-1769698678497-c41f0ab47c3e",
        code: "03",
    },
    {
        slug: "highrise-residential",
        title: "Highrise & Master Planning",
        short: "Urban towers and multi-phase developments built to scale.",
        sub: ["Residential Towers", "Mixed-Use", "Master Planning", "District Systems"],
        image: "https://images.pexels.com/photos/32831921/pexels-photo-32831921.jpeg",
        code: "04",
    },
    {
        slug: "education",
        title: "K-12 & Higher Education",
        short: "Campuses designed for focus, flexibility and a sustainable future.",
        sub: ["K-12 Schools", "University Labs", "Student Housing", "Athletics"],
        image: "https://images.unsplash.com/photo-1562774053-701939374585?w=1600",
        code: "05",
    },
    {
        slug: "commercial",
        title: "Commercial",
        short: "Office HQs, workplaces and retail environments that perform.",
        sub: ["Corporate HQ", "Workplace", "Retail", "Hospitality"],
        image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1600",
        code: "06",
    },
];

export const services = [
    {
        icon: "Wind",
        title: "Mechanical",
        tag: "HVAC · Cleanrooms · Process Cooling",
        desc: "Thermal systems engineered for the most demanding environments — from ISO-5 cleanrooms to liquid-cooled data halls.",
        bullets: ["HVAC design & energy modeling", "Cleanroom & process cooling", "Central plant design and optimization", "Environmental air permitting", "Combustible / hazardous dust collection systems", "Process exhaust systems"],
    },
    {
        icon: "Zap",
        title: "Electrical",
        tag: "Power · Distribution · Redundancy",
        desc: "High-performance power infrastructure with precision redundancy — from 480V switchgear to UPS-backed critical loads.",
        bullets: ["Power distribution & switchgear", "Emergency & backup systems", "Lighting design & controls", "System controls & low voltage"],
    },
    {
        icon: "Droplets",
        title: "Plumbing",
        tag: "Water · Gas · Waste Systems",
        desc: "Integrated plumbing, process piping and sanitary systems designed for efficiency, compliance and longevity.",
        bullets: ["Domestic water & sanitary", "Medical & lab gas systems", "Process piping & waste treatment", "Storm & rainwater management"],
    },
    {
        icon: "Flame",
        title: "Fire Protection",
        tag: "Detection · Suppression · Safety",
        desc: "Life-safety engineering that balances code compliance with operational continuity across every project type.",
        bullets: ["Sprinkler & standpipe design", "Clean agent suppression", "Smoke control & evacuation", "Fire alarm systems", "Hazmat review & code compliance"],
    },
    {
        icon: "Leaf",
        title: "Sustainability",
        tag: "LEED · Energy · Decarbonization",
        desc: "From LEED certification to net-zero pathways — we help owners hit targets without compromising performance.",
        bullets: ["LEED & WELL certification", "Energy modeling & audits", "Decarbonization roadmaps", "Electrification strategy"],
    },
    {
        icon: "LineChart",
        title: "Commissioning",
        tag: "Cx · RCx · Performance Testing",
        desc: "Rigorous verification that every system performs as designed — and continues performing through years of operation.",
        bullets: ["New-build commissioning", "Retro-commissioning", "Ongoing monitoring-based Cx", "Performance testing & validation"],
    },
];

export const stats = [
    { value: "10+", label: "Years of engineering excellence" },
    { value: "240", label: "Projects delivered globally", suffix: "+" },
    { value: "25M", label: "Square feet engineered", suffix: "+ SF" },
    { value: "8", label: "Industry sectors served" },
];

export const featuredProjects = [
    {
        title: "Semiconductor Facility",
        sector: "Advanced Manufacturing",
        location: "Chandler, AZ",
        scope: "4.8M SF · MEP + Process Utilities",
        image: "https://images.pexels.com/photos/18471441/pexels-photo-18471441.jpeg",
        year: "2021",
    },
    {
        title: "Hyperscale Data Center Campus",
        sector: "Mission Critical",
        location: "Santa Teresa, NM",
        scope: "1,400-acre · 2.7 Gigawatt Campus",
        image: "https://images.unsplash.com/photo-1680992046626-418f7e910589",
        year: "2024",
    },
    {
        title: "Medical Hospital Tower",
        sector: "Healthcare",
        location: "Sugar Land, TX",
        scope: "52 Additional Beds · 125 Total",
        image: "https://images.unsplash.com/photo-1516549655169-df83a0774514?w=1600",
        year: "2023",
    },
    {
        title: "EV & Battery Gigafactory",
        sector: "Advanced Manufacturing",
        location: "Austin, TX & SC, USA",
        scope: "10M + 5M SF · 1,400-acre Site Utility Design",
        image: "https://images.unsplash.com/photo-1617788138017-80ad40651399?auto=format&fit=crop&w=1600&q=80",
        year: "2023",
    },
];
